routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.myPaymentsList', {
      url: "mis-pagos/listado",
      template: `<my-payments-list sh-ctrl="shCtrl"></my-payments-list>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/pay-zone/my-payments/my-payments-list/my-payments-list.config.js
 **/